/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowUpArrowDownH: {
  name: 'arrow-up-arrow-down-h';
  data: string;
} = {
  name: 'arrow-up-arrow-down-h',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M17.707 3.293a1 1 0 1 0-1.414 1.414L17.586 6H4a1 1 0 0 0 0 2h13.586l-1.293 1.293a1 1 0 0 0 1.414 1.414l3-3a1 1 0 0 0 0-1.414l-3-3Zm-10 11.414a1 1 0 1 0-1.414-1.414l-3 3a1 1 0 0 0 0 1.414l3 3a1 1 0 0 0 1.414-1.414L6.414 18H20a1 1 0 1 0 0-2H6.414l1.293-1.293Z" fill="currentColor"/></svg>`,
};
